import React, { Component } from 'react';
import { Link } from "react-router-dom";
import {
    Icon,
    Card,
    Radio
} from 'antd';
import moment from 'moment';
import { Translate } from 'react-translated';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class StatBox extends Component {
    render() {
        const { title, val, color } = this.props;

        const gridStyle = {
            width: '100%',
            textAlign: 'center'
        };

        return (
            <Card.Grid style={gridStyle} className={["card-"+color, "card-cols-1"]}>
                <div className="value"><Link to={this.props.link}>{val}</Link></div>
                <div className="title"><Translate text={title} /></div>
            </Card.Grid>
        )
    }
}

class ReviewScheduledCalls extends Component {
    state = {
        callsType: "My Calls"
    }
    render() {

        const {
            dashboard, loading, period, start_date, end_date,carrier
        } = this.props;

        const { callsType } = this.state;

        if (typeof dashboard.agency_stats === "undefined") {
            dashboard.agency_stats = {
                review_scheduler_bfiles: 0
            }
        }

        let date_url = '';
        if (period === 'from_to') {
            date_url = '/all/' + encodeURIComponent(moment(start_date).format('MM/DD/YYYY')) + '/' + encodeURIComponent(moment(end_date).format('MM/DD/YYYY'))
        }
        if (period === 'all_bfiles') {
            date_url = '?all_bfiles';
        }

        return (
            <div style={{marginBottom: 20}}>
                <Card
                    title={
                        <div>
                            <Icon type="check-circle-o" style={{marginRight: 10,color:"#1890ff"}} />
                            <Translate text={`${carrier !== "Country Financial" ? "Review":""} Calls`} />
                        </div>
                    }
                    bordered={false}
                    extra={
                        <RadioGroup onChange={(e) => this.setState({ callsType: e.target.value })} defaultValue={callsType}>
                            <RadioButton value="My Calls"><Translate text={`My Calls`} /></RadioButton>
                            <RadioButton value="Agency Calls"><Translate text={`Agency Calls`} /></RadioButton>
                        </RadioGroup>
                    }
                    className="statsDetails pendingOpportunities"
                >
                    <div className="statsGrid">
                        {callsType === "My Calls" ? (
                            <Card bordered={false} loading={loading}>
                                <StatBox title={`${carrier !== "Country Financial" ? "Review":""} Scheduled Calls`} val={dashboard.stats.user_review_scheduler_bfiles} color={'red'} link={'/bfiles/review-scheduler-bfiles-mycalls' + date_url} />
                            </Card>
                        ) : (
                            <Card bordered={false} loading={loading}>
                                <StatBox title={`${carrier !== "Country Financial" ? "Review":""} Scheduled Calls`} val={dashboard.agency_stats.review_scheduler_bfiles} color={'red'} link={'/bfiles/review-scheduler-bfiles' + date_url} />
                            </Card>
                        )}
                    </div>
                </Card>
            </div>
        )
    }
}

export default ReviewScheduledCalls



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/ea-calculator-only/review-scheduled-calls.js